module.exports = __webpack_public_path__ + "img/payment_desktop.b4b6295a.svg";